<template>
  <svg
    id="Component_1"
    data-name="Component 1"
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 16 16"
  >
    <path
      id="Path_102"
      data-name="Path 102"
      d="M0,14H16v2H0ZM0,7H16v5H0ZM7,0h9V5H7ZM0,0H5V5H0Z"
      fill="#f0324c"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    }
  }
}
</script>
